<div class="col-12 mt-4">
  <p-confirmDialog></p-confirmDialog>
  <div class="col-12 flex">
    <div class="col-2 ml-5">
      <p-table selectionMode="single" [value]="headers" (onRowSelect)="onTabChange($event)">
        <ng-template pTemplate="body" let-item>
          <tr [pSelectableRow]="item.value">
            <td class="text-center font-weight-bold">{{item.field}} <label class="m-o float-right">></label></td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <div class="col-9 p-2 m-3 border border-info rounded topDivSpacing" *ngIf="selectedTab == 'batch'">
      <label class="h4 p-2">Search</label>
      <div class="col-12 p-2" style="margin-top: 5px;">
        <p-dropdown placeholder="Choose Search" [options]="searchFilterList" name="searchFilterList"
          [(ngModel)]="selectedSearchFilter">
        </p-dropdown>
        <input pInputText #idInput id="searchField" name="SearchSample" [(ngModel)]="valueToSearch"
          (keydown.enter)="search(idInput.value)"
          style="border-radius: 5px; height: 36px; width: 29rem; margin-left: 1%; margin-right: 1%; padding: 0.5rem;" />
        <button pButton label="Go" [disabled]="disableSearchIf(idInput.value)" (click)="search(idInput.value)"
          style="padding: 0.5rem; height: 36px; margin-bottom: 0.2%; border-radius: 5px;"></button>
      </div>
      <div class="col-12" *ngIf="searchSuccess">
        <div class="col-12 mt-3 border border-info rounded">
          <div class="text-center">
            <div class="col-12">
              <label class="h5 m-3">
                {{searchedBatch?.batchID}}
              </label>
            </div>
            <div class="col-12">
              <div class="col-12 button-container">
                <div class="col-3 ui-inputgroup" id="inputClass">
                  <button pButton class="theme-button labelButton" style="width: 40%;" type="button"
                    label="Sender"></button>
                  <input pInputText placeholder="Sender Name" [value]="searchedBatch?.sender" readonly />
                </div>
                <div class="col-3 ui-inputgroup" id="inputClass">
                  <button pButton class="theme-button labelButton" style="width: 40%;" type="button"
                    label="External ID"></button>
                  <input pInputText placeholder="External ID" [value]="searchedBatch?.externalIdentification"
                    readonly />
                </div>
                <div class="col-3 ui-inputgroup" id="inputClass">
                  <button pButton class="theme-button labelButton" style="width: 40%;" type="button"
                    label="Status"></button>
                  <input pInputText placeholder="Status of the Batch" [value]="searchedBatch?.statusOfTheBatch"
                    readonly />
                </div>
              </div>
              <div class="col-12 button-container">
                <div class="col-4 ui-inputgroup" id="inputClass">
                  <button pButton class="theme-button labelButton" style="width: 40%;" type="button"
                    label="Sample Count"></button>
                  <input pInputText placeholder="Sample Count" [value]="searchedBatch?.samples?.length" readonly />
                </div>

                <div class="col-4 ui-inputgroup" id="inputClass">
                  <button pButton class="theme-button labelButton" style="width: 40%;height: 50px;" type="button"
                    label="Batch Received Date" (click)="updateBatchReceivedDate()"></button>
                  <p-calendar [(ngModel)]="dateValue" [showTime]="true" [dateFormat]="dateFormat"
                    [hideOnDateTimeSelect]="true">
                  </p-calendar>

                </div>

                <div class="col-4 ui-inputgroup" id="inputClass">
                  <button pButton class="theme-button labelButton" style="width: 40%; height: 50px;  font-size: 0.9rem;"
                    type="button" label="Delivery Target Date"></button>
                  <input pInputText placeholder="Delivery Recieved Date" style="height: 50px;"
                    value="{{getDeliveryTargetDate() | date: dateTimeFormat }}" readonly />
                </div>
              </div>

              <div class="col-12 p-1">
                <button pButton class="font-weight-bold" label="View All Comments" icon="fa fa-comments"
                  (click)="showComments(true)" style="height: 36px;"></button>
              </div>
            </div>

          </div>
          <p-fieldset legend="Update Batch" toggleable="true">
            <div class="col-12 button-container">
              <div class="col-6 ui-inputgroup" id="inputClass">
                <button pButton class="theme-button labelButton" type="button" label="Update Status"
                  [disabled]="!selectedResetStatus" (click)="resetStatus()"></button>
                <p-dropdown [options]="statusSelectionList" [(ngModel)]="selectedResetStatus"
                  [style]="{ 'height' : '100%','width': '217px'}" placeholder="Reset batch to status"
                  [disabled]="!validRole">
                </p-dropdown>
              </div>
              <div class="col-6">
                <button type="button" class="btn btn-danger float-left" [disabled]="removeDisabledIf()"
                  (click)="confirmRemoveBatch()">Remove Batch</button>
              </div>
            </div>
            <div class="col-12">
              <div class="col-6 ui-inputgroup" id="inputClass">
                <button pButton class="theme-button greenButton" [disabled]="disableRenameButtonIf(renameInput.value)"
                  type="button" label="Rename Batch" (click)="renameBatch()"></button>
                <input pInputText placeholder="New batch name" [disabled]="disableRenameFieldIf(renameInput.value)"
                  style="width: 217px;" #renameInput id="renameField" [(ngModel)]="newBatchID"
                  (keydown.enter)="renameBatch()" />
              </div>
            </div>
          </p-fieldset>
        </div>
      </div>
      <div class="col-12 m-3 button-container" *ngIf="sampleSearch">
        <hr>
        <div class="col-8 p-0">
          <table aria-describedby="Sample Information Table" class="sampleTable">
            <tbody class="sampleTableBody">
              <tr>
                <th scope="row">Barcode</th>
                <td>{{sampleInfo.barcode}}</td>
                <th scope="row">Document Barcode</th>
                <td>{{sampleInfo.documentBarcode}}</td>
              </tr>
              <tr>
                <th scope="row">Customer Barcode</th>
                <td>{{sampleInfo.customersBarcode}}</td>
                <th scope="row">Box ID</th>
                <td>{{sampleInfo.boxId}}</td>
              </tr>
              <tr>
                <th scope="row">Unboxing Batch</th>
                <td>{{sampleInfo.unboxedBatch}}</td>
                <th scope="row">Clipping Batch</th>
                <td>{{sampleInfo.clippingBatch}}</td>
              </tr>
              <tr>
                <th scope="row">Analysis Batch</th>
                <td>{{sampleInfo.analysisBatch}}</td>
                <th scope="row">Status</th>
                <td>{{sampleInfo.status}}</td>
              </tr>
              <tr>
                <th scope="row">Sender</th>
                <td>{{sampleInfo.sender}}</td>
                <th scope="row">Contamination</th>
                <td>{{getContaminationString(sampleInfo)}}</td>
              </tr>
              <tr>
                <th scope="row">Result</th>
                <td class="text-uppercase font-weight-bold" [ngStyle]="getStyleForResult(sampleInfo.result)">
                  {{sampleInfo.result}}</td>
                <th scope="row">Position</th>
                <td>{{getPositionString(sampleInfo.positionRow, sampleInfo.positionCol)}}</td>
              </tr>
              <tr>
                <th scope="row">Sample Origin</th>
                <td>{{sampleInfo.sampleOrigin}}</td>
                <th scope="row">RT-PCR Kit</th>
                <td>{{sampleInfo.rtPCRKit}}</td>
              </tr>
              <tr>
                <th scope="row">Sender Contact Id</th>
                <td>{{sampleInfo.contactId}}</td>
                <th scope="row">Catalog OrderItem Id</th>
                <td>{{sampleInfo.catalogOrderItemId}}</td>
              </tr>
              <tr>
                <th scope="row">Redo Batches</th>
                <td colspan="3">{{sampleInfo.redoBatches}}</td>
              </tr>
              <tr>
                <th scope="row">Comments</th>
                <td colspan="3"><button pButton class="p-1 font-weight-bold" label="View All Comments"
                    icon="fa fa-comments" (click)="showComments(false)"></button></td>
              </tr>
            </tbody>
          </table>
          <table class="sampleTable" aria-describedby="Channels Table"
            *ngIf="sampleInfo.channels && sampleInfo.channels.length > 0">
            <tbody class="sampleTableBody">
              <tr>
                <th scope="row" style="width: 25%;">Channels</th>
                <td [ngClass]="channel.geneResult? 'text-danger font-weight-bold': 'text-success font-weight-bold'"
                  *ngFor="let channel of sampleInfo.channels">
                  {{channel.gene}}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-3">
          <div class="btn-group">
            <button class="btn btn-danger dropdown-toggle" type="button" data-toggle="dropdown" [disabled]="!validRole"
              aria-haspopup="true" aria-expanded="false">
              Delete Sample From
            </button>
            <div class="dropdown-menu">
              <a class="dropdown-item" (click)="batchIdPopup=true">Single Batch</a>
              <a class="dropdown-item" (click)="deleteSample(idInput)">All Batches</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-10 border border-info rounded topDivSpacing" *ngIf="selectedTab == 'order'">
      <label class="h4 p-2">Interface</label>
      <div class="col-12 p-2 d-flex">
        <p-radioButton name="groupname" class="ml-5" value="sendOrder" label="Send Order" [(ngModel)]="searchSelection"
          (onClick)="radioOnClick($event)"></p-radioButton>
        <p-radioButton name="groupname" class="ml-5" value="updateOrder" label="Update Results"
          [(ngModel)]="searchSelection" (onClick)="radioOnClick($event)"></p-radioButton>
        <p-radioButton name="groupname" class="ml-5" value="findOrder" label="Fetch Order" [(ngModel)]="searchSelection"
          (onClick)="radioOnClick($event)"></p-radioButton>
        <p-radioButton name="groupname" class="ml-5" value="delivery" label="Delivery" [(ngModel)]="searchSelection"
          (onClick)="radioOnClick($event)"></p-radioButton>
        <p-radioButton name="groupname" class="ml-5" value="invoice" label="Invoice" [(ngModel)]="searchSelection"
          (onClick)="radioOnClick($event)"></p-radioButton>
      </div>

      <div class="col-8"
        *ngIf="searchSelection=='sendOrder' || searchSelection=='updateOrder' || searchSelection=='findOrder' || searchSelection=='delivery' || searchSelection=='invoice'">
        <div class="col-12 flex">
          <hr>
          <div class="col-4"></div>
          <div class="col-4">
            <div *ngIf="searchSelection!='findOrder' && searchSelection!='delivery' && searchSelection!='invoice'">
              <label *ngIf="searchSelection=='sendOrder'">Upload Order:</label>
              <label *ngIf="searchSelection=='updateOrder'">Upload Order Result:</label>
              <input pInputText class="form-control" name="resultUpload" type="file" multiple="false" accept=".json"
                (change)="onResultFileChange($event)" id="resultFileChooser" placeholder="Upload Order JSON" />
            </div>
            <div class="col-12 p-0 flex" *ngIf="searchSelection=='findOrder'">
              <input pInputText class="p-2" type="text" #idInput2 id="searchInterfaceField"
                placeholder="Enter ID to search" (keyup.enter)="searchInterface(idInput2.value)" />
              <button pButton class="p-2 border-round" label="Go" [disabled]="disableSearchIf(idInput2.value)"
                (click)="searchInterface(idInput2.value)"></button>
            </div>
            <div class="col-12 p-0 flex" *ngIf="searchSelection=='delivery'">
              <input pInputText class="p-2" type="text" #idInput3 id="fetchDeliveryField"
                placeholder="Enter delivery to search" (keyup.enter)="fetchDelivery(idInput3.value)" />
              <button pButton class="p-2 border-round" label="Go" [disabled]="disableSearchIf(idInput3.value)"
                (click)="fetchDelivery(idInput3.value)"></button>
            </div>
            <div class="col-12" style="margin-left: -16rem;width: 100rem;" *ngIf="searchSelection=='invoice'">
              <div>
                <button pButton [disabled]="true" type="button" label="From"></button>
                <p-calendar [(ngModel)]="fromDate" size="5" dateFormat="yy-mm-dd" [showIcon]="true">
                </p-calendar>
                <button pButton [disabled]="true" type="button" class="ml-2" label="Until"></button>
                <p-calendar class="mr-2" [(ngModel)]="untilDate" size="5" dateFormat="yy-mm-dd" [showIcon]="true">
                </p-calendar>
                <button pButton label="View" (click)="fetchInvoicedOrders()"></button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 flex"
          *ngIf="searchSelection!='findOrder' && searchSelection!='delivery' && searchSelection!='invoice'">
          <div class="col-1"></div>
          <div class="col-10">
            <div>
              <textarea class="orderTextArea" id="orderRequestId" type="text" name="orderRequest"
                [(ngModel)]="requestJson" placeholder="Upload a file or copy paste the Order request here"
                rows="15"></textarea>
            </div>
            <div>
              <button pButton id="orderRequestSubmitButton" class="buttonsRound thirdButton mt-2"
                label="{{ searchSelection=='sendOrder' ? 'Submit Order' : 'Update Results'}}"
                [disabled]=" requestJson==null || requestJson==''" (click)="submitRequest()"
                style="margin-left:40%;"></button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-8" *ngIf="searchSelection=='findOrder'">

        <div class="col-1"></div>
        <div class="col-12 flex">
          <div class="col-10">
            <div>
              <textarea class="orderTextArea" id="orderSearchJsonId" type="text" name="orderSearchJson"
                placeholder="Order details would be displayed here" rows="15"></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-9 border border-info rounded topDivSpacing" *ngIf="selectedTab == 'library'">
      <div class="col-12">
        <label class="h4">Update Libraries</label>
      </div>
      <div class="col-8 flex">
        <div class="col-3">
          <p-fileUpload #fileUploader [style]="getFileUploadStyle()" (onSelect)="onCustomerFileSelect($event)"
          (uploadHandler)="onCSVUpload($event, fileUploader)" mode="basic" customUpload="true" accept=".csv"
          chooseLabel="Upload CSV" auto="true" [disabled]="!validRole"></p-fileUpload>
        </div>
        <div class="col-6">
          <button pButton class="templateRound btn h-3rem" icon="fa fa-download" label="Template" (click)="onTemplateClick()"
          [disabled]="!validRole"></button>
        </div>

      </div>
    </div>
  </div>

  <div class="col-12" *ngIf="searchSelection=='delivery' || searchSelection=='invoice'">
    <div class="col-12">
      <p-table [columns]="deliveryOrdersCols" [value]="deliveryOrdersList" [resizableColumns]="true"
        columnResizeMode="expand" selectionMode="single" [(selection)]="selectedDeliveryOrder"
        (onRowSelect)="handleDeliveryRowSelect($event)" [scrollable]="true" scrollHeight="300px">
        <ng-template pTemplate="caption">
          {{title}}
        </ng-template>
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th id="{{col.field+'Column'}}" *ngFor="let col of columns" [pSortableColumn]="col.field">
              {{col.header}}
              <p-sortIcon [field]="col.field"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <tr [pSelectableRow]="rowData">
            <ng-container *ngFor="let col of columns">
              <ng-template [ngIf]="col.showInGrid">
                <td class="wrapword textalign"
                  *ngIf="!checkIfFieldIsDate(col.field) && !checkIfFieldIsBoolean(col.field) && !checkIfFieldIsButton(col.field)">
                  {{ rowData[col.field] }}
                </td>
                <td class="wrapword textalign"
                  *ngIf="checkIfFieldIsDate(col.field) && !checkIfFieldIsButton(col.field)">
                  {{ rowData[col.field] | date:'dd.MM.yy HH:mm' }}
                </td>
                <td class="wrapword textalign" *ngIf="checkIfFieldIsButton(col.field)">
                  <button type="button" pButton (click)="fixSample(rowData)" [disabled]="!disableBUtton(rowData)"
                    label="Fix Sample"></button>
                </td>
                <td class="wrapword textalign" *ngIf="checkIfFieldIsBoolean(col.field)">
                  <p-checkbox disabled [(ngModel)]="rowData[col.field]" binary="true"></p-checkbox>
                </td>
              </ng-template>
            </ng-container>
          </tr>
        </ng-template>
        <ng-template pTemplate="summary" let-rowData>
          <div class="text-right">
            <button type="button" class="mr-3 p-2" pButton icon="pi pi-plus" disabled label="Add"></button>
            <button type="button" class="p-2" pButton icon="pi pi-save" disabled label="Export"></button>
          </div>
        </ng-template>
      </p-table>
      <button pButton class="p-2" label="Fix Delivery" [disabled]="!disableBUtton2()" (click)="fixDelivery()"></button>
    </div>
  </div>


  <div class="col-9 border border-info rounded topDivSpacing" *ngIf="selectedTab == 'library'"
    style="margin-left:18.25%">
    <div class="col-12">
      <label class="h4">Search</label>
    </div>
    <div class="col-6">
      <div class="ui-inputgroup" id="inputClass">
        <p-dropdown [options]="runSearchOptions" [(ngModel)]="selectedRunSearch" [filter]="true"
          [style]="{'width':'90%','height':'3rem'}" placeholder="Select a search criteria" [showClear]="true"></p-dropdown>
        <input pInputText name="SearchRunId" [(ngModel)]="inputRunId" size="17" [disabled]="!getDisabledForInput()"
          style=" border-radius: 1px;width: 36%; height: 3rem;" />
        <button pButton label="Go" class="border-round-sm p-0 h-3rem" style="width: 6%;" [disabled]="!getDisabledForGoButton()"
          (click)="getRunDetails()"></button>
      </div>
    </div>
    <div class="col-6">

    </div>
    <div class="col-12 border border-info rounded topDivSpacing" *ngIf="runDetailShow">
      <div class="col-12">
        <label class="h4" style="margin-left: 30em;">RUN {{selectedRun.runId}}</label>
      </div>
      <div class="col-12 flex ui-inputgroup">
        <div class="ui-inputgroup userIdLable flex" style="margin-top: 10px; width:25%; margin-left: 2%;">
          <button pButton class="theme-button noHover labelButton h-3rem border-round-left" type="button" label="Sequencer Type"
            style="width: 40%;"></button>
          <input pInputText name="UserPUID" class="h-3rem border-round-right" [(ngModel)]="selectedRun.sequencerType" size="10" maxlength="4"
            style="width: 59%; border-radius: 1px;" readonly />
        </div>
        <div class="ui-inputgroup userIdLable flex" style="margin-top: 10px; width:25%; margin-left:10%;">
          <button pButton class="theme-button noHover labelButton h-3rem border-round-left" type="button" label="Flowcell"
            style="width: 55%;"></button>
          <input pInputText name="UserPUID" class="h-3rem border-round-right" [(ngModel)]="selectedRun.flowCellName" size="10" maxlength="4"
            style="width: 59%;" readonly />
        </div>
        <div class="ui-inputgroup userIdLable flex" style="margin-top: 10px; width:25%; margin-left:10%;">
          <button pButton class="theme-button noHover labelButton border-round-left" type="button" label="Read Mode"
            style="width: 40%;"></button>
          <input pInputText name="UserPUID" class="h-3rem border-round-left" [(ngModel)]="selectedRun.largestReadMode" size="10" maxlength="4"
            style="width: 62%; height: 3rem;" readonly />
        </div>
      </div>
      <div class="col-12 flex ui-inputgroup">
        <div class="ui-inputgroup userIdLable" style="margin-top: 10px; width:25%; margin-left: 2%;">
          <button pButton class="theme-button noHover h-3rem border-round-left" type="button" label="Machine"
            style="width: 40%; background-color: #007bff"></button>
          <p-dropdown [options]="runMachineOptions" placeholder="Select Machine" [(ngModel)]="runMachine" [filter]="true"
            [style]="{'width':'17em','height':'3rem'}" [showClear]="true" [disabled]="disableCalendar()"></p-dropdown>
        </div>
        <div class="ui-inputgroup userIdLable" style="margin-top: 10px; width:25%; margin-left:10%;">
          <button pButton class="theme-button noHover h-3rem border-round-left" type="button" label="Start Date (Planned)"
            style="width: 48%;"></button>
          <p-calendar class="datePicker" [(ngModel)]="startDate" [dateFormat]="dateFormat" [showTime]="true"
            [style]="{'height':'100%','width':'52%', 'border-radius':'0px 5px 5px 0px'}" (onSelect)="calculateRunFinishDate()" (onInput)="calculateRunFinishDate()"
            [inputStyle]="{'width':'108%','height':'98%'}"
            [disabled]="disableCalendar()"></p-calendar>
        </div>
        <div class="ui-inputgroup userIdLable flex" style="margin-top: 10px; width:25%; margin-left:10%;">
          <button pButton class="theme-button noHover labelButton h-3rem border-round-left" type="button" label="Status"
            style="width: 40%;"></button>
          <input pInputText name="UserPUID" [(ngModel)]="selectedRun.status" size="10" maxlength="4"
            style="width: 62%; border-radius: 1px; height: 98%;" readonly />
        </div>
      </div>
      <div class="col-12 flex ui-inputgroup" style="margin-top:1%;">
        <div class="col-6 processingTableBody  pt-0 p-0">
          <div class="border-bottom headerDiv text-center">Comments</div>
          <div class="col-12" style="height: 100%; ">
            <div class="col-6 p-0 text-left">
              <label class="font-weight-bold commentBatchId">{{previewComment?.runId}}</label>
            </div>
            <div class="col-6 p-0 text-right">
              <label class="commentPUIDDate">{{previewComment?.puid}} | {{previewComment?.commentDate | date:
                dateTimeFormat}}</label>
            </div>
            <div class="col-12">
              <textarea [(ngModel)]="previewComment.userComment" type="text" name="comment"
                style="width:100% ;font-size: medium;" placeholder="No comments entered" rows="5" id="commentArea"
                readonly></textarea>
              <button pButton class="font-weight-bold commentButton" label="View/Add Comments"
                (click)="showRunComments()"></button>
            </div>

          </div>
        </div>
        <div class="col-6">
          <button pButton class="theme-button noHover border-round" type="button" label="Update" (click)="checkOverlapRuns()"
            [disabled]="disableCalendar()"
            style="width: 25%; height: 20%; margin-left: 23%;margin-top: 18%; background-color: #1F618D;"></button>
        </div>
      </div>
    </div>

    <p-dialog header="View Order Detail" [(visible)]="showDeliveryOrder" [modal]="true" [dismissableMask]="true">
      <div>
        <textarea style="width: 38rem; height: 40rem;" class="orderTextArea" id="deliveryOrderJsonId" type="text"
          name="deliveryOrderJson" placeholder="Order details would be displayed here" rows="20"></textarea>
      </div>
    </p-dialog>

    <p-dialog header="{{batchID + ' Comments'}}" [(visible)]="showCommentDialog" [modal]="true">
      <div class="border border-info" id="commentShowDiv">
        <div class="col-12" *ngFor="let batch of getCommentKeys(commentsMap)">
          <div class="col-12 p-0 rounded border border-secondary commentBubble">
            <div class="col-11 pb-0">
              <label>{{batch}}</label>
            </div>
            <div class="col-1 pb-0">
              <button *ngIf="batchCommentVisibility.get(batch)" type="button"
                class="float-right btn btn-outline-secondary border-0 p-0"
                (click)="toggleBatchContent(batch, false)"><em class="fa fa-window-minimize"></em></button>
              <button *ngIf="!batchCommentVisibility.get(batch)" type="button"
                class="float-right btn btn-outline-secondary border-0 p-0" (click)="toggleBatchContent(batch, true)"><em
                  class="fa fa-window-maximize"></em></button>
            </div>
            <div *ngIf="batchCommentVisibility.get(batch)">
              <div *ngFor="let comment of commentsMap.get(batch)">
                <div class="col-12 p-0 commentBubbleSection">
                  <div class="col-12 commentPUIDDate">
                    <label>{{comment.puid}} | {{comment.commentDate | date: dateTimeFormat}}</label>
                  </div>
                  <div class="col-12 commentPUIDDate font-weight-bold">
                    <p>{{comment.userComment}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p-footer>
        <button pButton label="OK" (click)="showCommentDialog = false"></button>
      </p-footer>
    </p-dialog>

    <p-dialog header="Enter BatchID" [(visible)]="batchIdPopup" [modal]="true" [dismissableMask]="true"
      (onHide)="batchIdToDeleteSample=null">
      <label class="text-danger">Scan Valid Batch ID To Delete Sample</label>
      <div>
        <input class="batchInput" pInputText type="text" name="comment" [(ngModel)]="batchIdToDeleteSample"
          (keyup.enter)="deleteSample()" />
      </div>
      <p-footer>
        <button pButton type="button" label="Delete" [disabled]="deleteDisabledIf()"
          (click)="deleteSample(idInput)"></button>
      </p-footer>
    </p-dialog>

    <p-dialog header="Confirm Rescheduling" [(visible)]="runReschedulePopup" [modal]="true" [dismissableMask]="true">
      <label>Dear User,</label><br>
      <label>Your reschedulling is causing an overlapping with following run(s):</label><br><br />
      <div>
        <ul>
          <li *ngFor="let item of overlapRunList">{{item}}</li>
        </ul>
      </div><br><br />
      <label>Please adjust the scheduling of listed runs or reject your changes.</label>
      <p-footer>
        <div class="ui-inputgroup userIdLable">
          <button pButton class="theme-button noHover" type="button" label="Reject" style="width:25%; margin-left:10%;"
            (click)="rejectReschedule()"></button>
          <button pButton class="theme-button noHover" type="button" label="Confirm" style="width:25%; margin-left:25%;"
            (click)="updateRunDetails()"></button>
        </div>
      </p-footer>
    </p-dialog>


    <p-dialog header="{{'RUN '+ selectedRun.runId +' Comments'}}" [(visible)]="showRunCommentDialog" [modal]="true"
      [baseZIndex]="1000">
      <div class="border border-info" id="commentShowDivRun">
        <div class="col-12" *ngFor="let run of getRunCommentKeys(runCommentsMap)">
          <div class="col-12 p-0 rounded border border-secondary commentBubble">
            <div class="col-11 pb-0">
              <label>RUN {{run}}</label>
            </div>
            <div class="col-1 pb-0">
              <button *ngIf="runCommentVisibility.get(run)" type="button"
                class="float-right btn btn-outline-secondary border-0 p-0" (click)="toggleRunContent(run, false)"><em
                  class="fa fa-window-minimize"></em></button>
              <button *ngIf="!runCommentVisibility.get(run)" type="button"
                class="float-right btn btn-outline-secondary border-0 p-0" (click)="toggleRunContent(run, true)"><em
                  class="fa fa-window-maximize"></em></button>
            </div>
            <div *ngIf="runCommentVisibility.get(run)">
              <div *ngFor="let comment of runCommentsMap.get(run)">
                <div class="col-12 p-0 commentBubbleSection">
                  <div class="col-12 commentPUIDDate">
                    <label>{{comment.puid}} | {{comment.commentDate | date: dateTimeFormat}}</label>
                  </div>
                  <div class="col-12 commentPUIDDate font-weight-bold">
                    <p>{{comment.userComment}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="commentTextAreDiv">
        <textarea pInputTextarea class="commentTextArea" placeholder="Add new comment here..."
          [(ngModel)]="this.newRunComment.userComment"></textarea>
      </div>
      <p-footer>
        <button pButton label="Add Comment" [disabled]="disableAddCommentButton()" (click)="saveComment()"></button>
      </p-footer>
    </p-dialog>

    <p-blockUI [blocked]="blocked">
      <div>
        <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
      </div>
    </p-blockUI>
